<template>
    <div class="z-20 bg-white text-sm text-gray-900 md:max-w-[600px] md:mx-auto">
        <i
            class="fas fa-times absolute left-2 top-2 cursor-pointer p-4 text-xl"
            @click="$emit('toggle')"
        ></i>
        <div class="h-full overflow-y-scroll px-4 py-12 md:px-8">
            <slot />
        </div>
    </div>
</template>
<script>
export default {
  name: "PanneauAide",
};
</script>
